import React, { memo } from 'react';
import styled from 'styled-components';
import { mediumMediaQuery, smallMediaQuery } from '../../../common/utilities/sizeHelpers';

interface MediaNavProps {
    children?: React.ReactNode;
}
export const MediaNav = memo((
    { children }: MediaNavProps
) => {
    return (
        <MediaNavBar>
            <Wrap>
                <PageSubNav>
                    {children}
                </PageSubNav>
            </Wrap>
        </MediaNavBar>
    );
});

MediaNav.displayName = 'MediaNav';

const MediaNavBar = styled.div`
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 13px;
`;

const Wrap = styled.div`
    display: flex;
    margin-top: 10px;
    @media ${mediumMediaQuery} {
        justify-content: center;
    }
`;

const PageSubNav = styled.div`
    display: flex;
    padding-left: 0;
    @media ${smallMediaQuery} {
        width: 100%;
    }
`;